﻿/**
 * SEO Default Configuration & Metadata Schemas
 * Connect Source Architecture
 */

export interface PageSEOProps {
  readonly title?: string;
  readonly description?: string;
  readonly canonicalUrl?: string;
  readonly ogImage?: string;
  readonly ogType?: 'website' | 'article' | 'product';
  readonly noIndex?: boolean;
  readonly jsonLd?: Record<string, unknown> | Array<Record<string, unknown>>;
}

export const defaultSEO = {
  siteName: 'Connect Source',
  defaultTitle: 'Connect Source — Career Transformation, HR & Business Support Platform',
  titleTemplate: '%s | Connect Source',
  defaultDescription: 'Empowering professionals and enterprises with executive career coaching, HR advisory, and actionable digital career kits.',
  baseUrl: 'https://connectsource.co.in',
defaultOgImage: 'https://connectsource.co.in/assets/og-default.jpg',
  twitterHandle: '@connectsourcein',
  robots: 'index, follow'
} as const;


